import React from 'react'
import Text from '@component/Text/Text'

const LivePolicyKorean = () => {
    return (
        <div className={'text-body1 text-gray02 dark:text-dark_gray02 px-[30px]'}>
            <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>
                League of Traders 실시간 채팅방(Live) 운영정책
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 1조 (목적)</Text>
            <Text className={'mt-[10px]'}>
                본 운영정책은 League of Traders(이하 &quot;서비스&quot;)에서 제공하는 실시간 채팅방(이하
                &quot;Live&quot;)의 원활하고 안전한 운영을 위해 사용자들이 준수해야 할 사항을 명시하는 것을 목적으로
                합니다.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 2조 (Live 이용 대상)</Text>
            <Text className={'mt-[10px]'}>
                &quot;Live&quot;는 회원가입 및 서비스 약관에 동의한 사용자만 이용할 수 있으며, 주식, 외환, 가상화폐 등
                트레이딩 정보 교류를 목적으로 합니다. 이 외의 용도로 &quot;Live&quot;를 이용하는 것은 금지됩니다.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 3조 (금지행위)</Text>
            <Text className={'mt-[10px]'}>&quot;Live&quot;에서 다음과 같은 행위는 금지됩니다:</Text>
            <Text className={'mt-[10px]'}>
                ① <strong>허위정보 유포:</strong> 트레이딩에 관한 허위정보 또는 확인되지 않은 정보를 고의적으로 유포하는
                행위.
                <br />② <strong>광고 및 홍보:</strong> 타인의 투자 상품, 서비스, 웹사이트, SNS 등을 홍보하거나 광고하는
                행위.
                <br />③ <strong>비방 및 인신공격:</strong> 특정 사용자 또는 제3자를 비방하거나 명예를 훼손하는 발언,
                욕설을 사용하는 행위.
                <br />④ <strong>불법 행위:</strong> 법령을 위반하는 내용의 정보 제공, 불법적인 트레이딩 활동을
                조장하거나 논의하는 행위.
                <br />⑤ <strong>사기 행위:</strong> 금전적 이득을 목적으로 한 사기성 발언, 사적 거래 유도.
                <br />⑥ <strong>개인정보 유출:</strong> 타인의 개인정보를 무단으로 수집하거나 유포하는 행위.
                <br />⑦ <strong>도배 및 스팸:</strong> 반복적인 동일 메시지 전송, 과도한 이모티콘 사용 등 정상적인 대화
                흐름을
            </Text>

            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 4조 (이용제한 및 제재)</Text>
            <Text className={'mt-[10px]'}>
                ① <strong>경고:</strong> 운영정책을 위반한 사용자는 경고를 받을 수 있으며, 반복적인 경고 누적 시 더 강한
                제재가 적용됩니다.
                <br />② <strong>일시 정지:</strong> 경고에도 불구하고 지속적인 위반이 발생할 경우 일정 기간 동안 채팅방
                이용이 일시 정지됩니다.
                <br />③ <strong>영구 이용정지:</strong> 중대한 위반 행위(예: 사기, 허위정보 유포 등) 발생 시, 사전 경고
                없이 즉시 &quot;Live&quot; 이용이 영구적으로 제한될 수 있습니다.
                <br />④ <strong>법적 조치:</strong> 법령을 위반하는 행위가 확인될 때, 법적 조치를 취할 수 있습니다.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 5조 (모니터링)</Text>
            <Text className={'mt-[10px]'}>
                서비스 운영자는 &quot;Live&quot;에서 발생하는 모든 대화를 모니터링할 권한이 있으며, 이용자들이 본
                운영정책을 준수하는지 여부를 확인할 수 있습니다. 위반 사항이 발견될 경우, 즉시 해당 이용자에 대해 조치를
                취할 수 있습니다.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 6조 (면책)</Text>
            <Text className={'mt-[10px]'}>
                League of Traders는 사용자 간의 트레이딩 정보 교환으로 인해 발생한 손해에 대해 책임을 지지 않으며,
                채팅방에서 유포된 정보의 정확성을 보장하지 않습니다. 사용자는 모든 트레이딩에 대한 판단과 책임을 본인이
                부담해야 합니다.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>제 7조 (정책의 변경)</Text>
            <Text className={'mt-[10px]'}>
                본 운영정책은 상황에 따라 변경될 수 있으며, 변경된 정책은 서비스 내 공지사항을 통해 사전 안내될
                것입니다. 사용자는 변경된 정책을 숙지하고 이를 준수할 의무가 있습니다.
            </Text>
        </div>
    )
}
export default LivePolicyKorean
